import {testIds} from '@dms/routes';
import {DmsDataGrid} from '@dms/shared';

import {useVehiclesActionCallback} from '../../hooks/useVehiclesActionCallback';
import {vehicleBulkOperationActionCallback} from '../../utils/vehicleBulkOperationActionCallback';

export function AdvertisedVehicles() {
  const [actionCallback] = useVehiclesActionCallback();

  return (
    <DmsDataGrid
      gridCode="vehicles-in-advertisement"
      data-testid={testIds.vehicles.home('advertisement')}
      // eslint-disable-next-line eslint-js/no-restricted-syntax
      key="vehicles-in-advertisement"
      actionCallback={actionCallback}
      bulkOperationActionCallback={vehicleBulkOperationActionCallback}
    />
  );
}
